<mat-toolbar color="accent">Generate MOH Prior Approval Request</mat-toolbar>

<div class="flex flex-col gap-3 p-4">
  <form class="flex flex-col gap-3" [formGroup]="form">
    <div class="flex gap-4">
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>MOH Claim Type</mat-label>
        <mat-select formControlName="claimType">
          @for (type of claimTypes; track type) {
            <mat-option
              [value]="type"
              [disabled]="type | map: claimTypeDisabled : this"
            >
              {{ type | map: getClaimTypeLabel }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>Patient NHI Number</mat-label>
        <input matInput type="text" formControlName="nhiNumber" />
      </mat-form-field>
    </div>

    <pr-moh-agreement-holder-form
      [form]="agreementHolderForm"
      [practice]="data.practice"
      [practitioner]="data.practitioner"
    />

    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Patient's condition and practitioner comments</mat-label>
      <textarea matInput formControlName="comments" rows="1"></textarea>
    </mat-form-field>
  </form>

  @if (isHighCaries$ | async) {
    <pr-moh-high-caries-request-form [form]="highCariesForm" />
  }

  @if (filteredCodes$ | async; as codes) {
    @if (codes.length) {
      <pr-moh-treatment-list-card
        title="Requiring Prior Approval"
        [codes]="codes"
      />
    }
  }

  <pt-buttons-container>
    <pt-loader-button
      color="primary"
      type="flat"
      [loading]="loading()"
      [disabled]="loading() || !form.valid"
      (clicked)="submit()"
      >Submit</pt-loader-button
    >
  </pt-buttons-container>
</div>
